<template>
<!--   Login Card   -->
            <v-card class="mx-lg-0 mx-md-0  mx-sm-auto d-flex flex-column justify-center align-center"
                         min-width="475"
                         max-width="500"
                         min-height="650"
                         color="white">
                   <v-container fluid >

                     <!--  PL Logo  -->
                     <v-row justify="space-between">
                       <v-col  cols="12" class="d-flex align-center justify-center">
<!--                         plFull-->
                         <div  class="pl-logo-block" data-cy="projectlink-logo">
                           <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 971.55 230"><defs><linearGradient id="linear-gradient" x1="53.71" y1="176.29" x2="240.01" y2="-10.01" gradientUnits="userSpaceOnUse"><stop offset=".38" stop-color="#90c63c"/><stop offset="1" stop-color="#aed571"/></linearGradient></defs><path d="M358.84,102.26c0,18.32-13.28,29.38-35.16,29.38h-23.11v27.17h-9.1v-86.06h32.21c21.88,0,35.16,11.06,35.16,29.5ZM349.75,102.26c0-13.77-9.1-21.64-26.31-21.64h-22.87v43.03h22.87c17.21,0,26.31-7.87,26.31-21.39Z" style="fill:#1b4759;"/><path d="M404.57,93.66v8.48c-.74,0-1.47-.12-2.09-.12-13.52,0-21.76,8.61-21.76,23.85v32.95h-8.73v-64.67h8.36v12.66c4.06-8.61,12.29-13.15,24.22-13.15Z" style="fill:#1b4759;"/><path d="M410.1,126.48c0-19.18,14.02-32.83,32.95-32.83s32.83,13.65,32.83,32.83-13.89,32.95-32.83,32.95-32.95-13.77-32.95-32.95ZM467.03,126.48c0-15.12-10.2-25.2-23.97-25.2s-24.1,10.08-24.1,25.2,10.33,25.2,24.1,25.2,23.97-10.08,23.97-25.2Z" style="fill:#1b4759;"/><path d="M467.39,179.1l3.07-6.64c2.58,2.21,6.02,3.32,10.08,3.32,6.88,0,10.7-4.18,10.7-12.17v-69.46h8.73v69.46c0,11.92-6.64,19.67-18.93,19.67-5.16,0-10.45-1.35-13.65-4.18ZM489.28,73.74c0-3.32,2.83-6.15,6.39-6.15s6.39,2.71,6.39,6.02c0,3.57-2.7,6.39-6.39,6.39s-6.39-2.83-6.39-6.27Z" style="fill:#1b4759;"/><path d="M577.55,129.19h-54.09c.98,13.52,11.31,22.5,25.45,22.5,7.87,0,14.88-2.83,19.79-8.48l4.92,5.66c-5.78,6.88-14.75,10.57-24.96,10.57-20.16,0-33.93-13.77-33.93-32.95s13.4-32.83,31.6-32.83,31.35,13.4,31.35,32.83c0,.74-.12,1.72-.12,2.7ZM523.45,122.67h45.86c-1.11-12.66-10.33-21.51-22.99-21.51s-21.76,8.85-22.87,21.51Z" style="fill:#1b4759;"/><path d="M585.9,126.48c0-19.3,14.01-32.83,33.32-32.83,10.94,0,20.16,4.3,25.33,12.79l-6.52,4.43c-4.43-6.52-11.31-9.59-18.81-9.59-14.14,0-24.46,10.08-24.46,25.2s10.33,25.2,24.46,25.2c7.5,0,14.38-2.95,18.81-9.47l6.52,4.43c-5.16,8.36-14.38,12.79-25.33,12.79-19.3,0-33.32-13.65-33.32-32.95Z" style="fill:#1b4759;"/><path d="M693.35,154.88c-3.44,3.07-8.61,4.55-13.65,4.55-12.17,0-18.93-6.88-18.93-18.81v-39.09h-11.56v-7.38h11.56v-14.14h8.73v14.14h19.67v7.38h-19.67v38.6c0,7.62,3.93,11.8,11.19,11.8,3.57,0,7.13-1.11,9.59-3.32l3.07,6.27Z" style="fill:#1b4759;"/><path d="M713.38,72.76h19.92v69.83h43.15v16.23h-63.07v-86.06Z" style="fill:#1b4759;"/><path d="M780.88,72.76c0-6.02,4.79-10.7,11.92-10.7s11.93,4.43,11.93,10.33c0,6.39-4.79,11.06-11.93,11.06s-11.92-4.67-11.92-10.7ZM783.21,92.68h19.18v66.14h-19.18v-66.14Z" style="fill:#1b4759;"/><path d="M884.76,120.95v37.87h-19.18v-34.92c0-10.7-4.92-15.61-13.4-15.61-9.22,0-15.86,5.66-15.86,17.83v32.7h-19.18v-66.14h18.32v7.75c5.16-5.66,12.91-8.73,21.88-8.73,15.61,0,27.42,9.1,27.42,29.26Z" style="fill:#1b4759;"/><path d="M927.42,132.88l-9.22,9.1v16.84h-19.18v-91.22h19.18v51.63l28.03-26.55h22.87l-27.54,28.03,30,38.11h-23.24l-20.9-25.94Z" style="fill:#1b4759;"/><rect width="230" height="230" rx="24.59" ry="24.59" style="fill:url(#linear-gradient);"/><path d="M115,154.15c-3.4,0-6.77-.48-10.01-1.42-4.39-1.28-6.91-5.86-5.64-10.25,1.27-4.39,5.86-6.91,10.25-5.64,1.75.51,3.56.76,5.4.76,10.76,0,19.51-8.75,19.51-19.5v-42.17c0-10.76-8.75-19.5-19.51-19.5s-19.5,8.75-19.5,19.5v21.79c0,4.57-3.7,8.27-8.27,8.27s-8.27-3.7-8.27-8.27v-21.79c0-19.88,16.17-36.05,36.05-36.05s36.06,16.17,36.06,36.05v42.17c0,19.88-16.17,36.05-36.06,36.05ZM95.49,181.86v-42.17c0-10.76,8.75-19.51,19.5-19.51,4.57,0,8.27-3.7,8.27-8.27s-3.7-8.27-8.27-8.27c-19.88,0-36.05,16.17-36.05,36.06v42.17c0,4.57,3.7,8.27,8.27,8.27s8.27-3.7,8.27-8.27Z" style="fill:#fff;"/></svg>
                         </div>
                       </v-col>

                       <v-col cols="12">
                         <!--   Error Message  -->
                         <v-row>
                           <v-col cols="12">
                             <v-alert v-if="failMessage" density="compact" variant="outlined" type="error" class="text-small mx-2" >{{failMessage}}</v-alert>
                           </v-col>
                         </v-row>

                         <!--   Login Form  -->
                         <v-row>
                           <v-col cols="12"  class="d-flex align-center justify-center" >
                             <v-card-text style="max-width: 400px;">
                               <h1 class="mb-6 text-gunmetal text-left">Login</h1>
                               <v-form action="/login" method="post" accept-charset="UTF-8" ref="form" data-cy="login-form">
                                 <input type="hidden" name="authenticity_token" id="authenticity_token" v-bind:value="csrfToken" />

                                 <v-label for="authentication_name"><span class="text-caption">Username</span></v-label>
                                 <v-text-field class="input-group--focused mt-1 pt-0"
                                               variant="outlined"
                                               density="compact"
                                               rounded="xl"
                                               prepend-inner-icon="mdi-account"
                                               type="text"
                                               name="authentication[name]"
                                               id="authentication_name"
                                               autocomplete="off"
                                               autofocus
                                               ref="name"
                                               :rules="nameRules"
                                               v-model="username"
                                               :error="invalidUserName"
                                               @keypress="onKeyPress"
                                               data-cy="username-input"
                                 />
                                 <v-label for="authentication_password"><span class="text-caption">Password</span></v-label>
                                 <v-text-field class="mt-1 pt-0"
                                               variant="outlined"
                                               density="compact"
                                               rounded="xl"
                                               @click:append-inner="showPassword = !showPassword"
                                               :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                               :type="showPassword ? 'text' : 'password'"
                                               prepend-inner-icon="mdi-lock"
                                               name="authentication[password]"
                                               id="authentication_password"
                                               autocomplete="off"
                                               ref="password"
                                               :error="invalidPassword"
                                               :rules="passwordRules"
                                               @keypress="onKeyPress"
                                               data-cy="password-input"
                                 />
                                 <v-btn v-if="!submitted"
                                        value="login" color="primary" variant="flat" rounded="0" block
                                        data-cy="login-btn"
                                        :loading="submitted"
                                        class="mt-4"
                                        @click="onSubmit">Sign in</v-btn>
                                 <v-btn v-if="submitted"
                                        color="primary"
                                        variant="flat" rounded="0" block loading />
                               </v-form>
                             </v-card-text>
                           </v-col>
                         </v-row>
                       </v-col>

                       <v-col cols="12">
                         <!--   Card Footer Information  -->
                         <v-row>
                           <v-col cols="12" class="text-caption text-center text-grey">&copy; {{date}} International Consumer Research & Testing Ltd.</v-col>
                         </v-row>
                       </v-col>
                   </v-row>
                 </v-container>
            </v-card>
</template>


<script>
import {mapMutations, mapGetters} from 'vuex';

export default {
    name: 'login-form',
    props: {
        token: {
          type: String,
        },
        notice: {
          type: String,
        },
        title: {
          type: String,
        },
        remote: {
          type: Boolean,
          required: true,
        }
    },

    data: function() {
        return {
            date: new Date().getFullYear(),
            username: null,
            showPassword: false,
            invalidUserName: false,
            invalidPassword: false,
            submitted: false,
            failMessage: null,
            csrfToken: null,
            attempts: 0,
            nameRules: [ v => !!v || 'Name is required', ],
            passwordRules: [ v => !!v || 'Password is required', ],
        }
    },

    computed: mapGetters(['user', 'images']),

    mounted() {
      if(!this.remote) {
        this.csrfToken = document.getElementById('app').dataset.csrf;
        this.failMessage = document.getElementById('app').dataset.notice;
        return;
      }
      this.username = this.user.name;
      this.$refs.password.focus();
      this.csrfToken = this.token;
      this.failMessage = this.notice;
    },

    watch: {
      attempts(count) {
        if(count > 1) window.location = window.location.href;
      }
    },

    methods: {
        ...mapMutations(['setError']),

      async validateForm() {
        const { valid } = await this.$refs.form.validate()
        if (valid) return true
        return false
      },

        async onSubmit() {
            if(await this.validateForm()){
              this.submitted = true;

              const {authentication_name, authentication_password} = this.$refs.form.getElementsByTagName('input');
              const valid = !!authentication_name.value && !!authentication_password.value;

              if(!valid) {
                this.invalidUserName = true;
                this.invalidPassword = true;
                this.failMessage = "Please enter valid username and password";
                this.submitted = false
                return false;
              }

              if(this.remote) return this.submitForm();
              this.$refs.form.submit();
            } else {

            }

        },

        onKeyPress(e) {
            if(e.keyCode === 13) this.onSubmit();
        },

        async submitForm() {
            try {
                //fetch csrf token
                const res = await this.axios.get('/login');
                const parser = new DOMParser();
                const doc = parser.parseFromString(res.data, 'text/html');
                this.csrfToken = doc.querySelector("meta[name='csrf-token']").getAttribute('content');

                const {authenticity_token, authentication_name, authentication_password} = this.$refs.form.getElementsByTagName('input');
                const form = `authenticity_token=${encodeURIComponent(this.csrfToken)}&authentication[name]=${encodeURIComponent(authentication_name.value)}&authentication[password]=${encodeURIComponent(authentication_password.value)}`;

              const vm = this;


                setTimeout(async () => {

                    const res = await vm.axios({
                      url: '/login.json',
                      method: 'POST',
                      data: form,
                      headers: {
                          "Content-Type": "application/x-www-form-urlencoded",
                      },
                      withCredentials: false,
                      maxRedirects: 0
                    });

                    vm.submitted = false;

                    if (!res.status) {
                        vm.invalidPassword = true;
                        vm.failMessage = 'Incorrect password - please try again';
                        vm.attempts += 1;
                        return;
                    }

                    await this.axios.get('/token');
                    window.location = window.location.href + '?' + Date.now()

                    vm.invalidPassword = false;
                    vm.failMessage = null;
                    vm.attempts = 0;
                    vm.$emit('closeLoginDialog');

                }, 0);
            } catch(error) {
                this.failMessage = error.notice || error;
            }
        },
    },
}
</script>

<style scoped>

</style>
